import { BanknotesIcon, BuildingLibraryIcon, CreditCardIcon } from '@heroicons/react/24/outline';
import { translate } from 'src/translate';
import { NON_MANAGED_PAYMENT_METHODS } from './nonManagedPaymentUtils';

function BitIcon({ className = 'h-10 w-10' }) {
  return (
    <img
      src="/bit.png"
      alt=""
      aria-hidden="true"
      className={`${className} rounded-md object-contain`}
    />
  );
}

function bitIconClass(className = 'h-5 w-5') {
  if (className.includes('h-3')) return className.replaceAll('h-3', 'h-6').replaceAll('w-3', 'w-6');
  if (className.includes('h-4')) return className.replaceAll('h-4', 'h-8').replaceAll('w-4', 'w-8');
  if (className.includes('h-5')) return className.replaceAll('h-5', 'h-8').replaceAll('w-5', 'w-8');
  if (className.includes('h-6')) return className.replaceAll('h-6', 'h-10').replaceAll('w-6', 'w-10');
  return className;
}

export function PaymentMethodGlyph({ method, className = 'h-5 w-5' }) {
  if (method === 'bit') return <BitIcon className={bitIconClass(className)} />;
  if (method === 'cash') return <BanknotesIcon className={className} />;
  if (method === 'card') return <CreditCardIcon className={className} />;
  if (method === 'transfer') return <BuildingLibraryIcon className={className} />;
  return null;
}

export function paymentMethodLabel(method, language) {
  const match = NON_MANAGED_PAYMENT_METHODS.find((item) => item.id === method);
  return match ? translate(match.labelKey, language) : '';
}

export function PaymentTypeCell({ invoice, language }) {
  if (invoice?.isNonManaged) {
    return (
      <span className="inline-flex items-center justify-center gap-1 text-gray-700">
        <PaymentMethodGlyph method={invoice.paymentMethod} className="h-5 w-5" />
        <span className="text-xs">{paymentMethodLabel(invoice.paymentMethod, language)}</span>
      </span>
    );
  }

  return (
    <span className="inline-flex items-center justify-center">
      <img src="/favicon.ico" alt="WATS" title="WATS" className="h-5 w-5" />
    </span>
  );
}

export default function PaymentMethodPicker({ value, onChange, language, spacious = false }) {
  return (
    <div
      className={
        spacious
          ? 'grid grid-cols-2 gap-3 sm:grid-cols-4'
          : 'grid grid-cols-4 gap-2'
      }
    >
      {NON_MANAGED_PAYMENT_METHODS.map((method) => {
        const selected = value === method.id;
        return (
          <button
            key={method.id}
            type="button"
            onClick={() => onChange(method.id)}
            className={`flex flex-col items-center justify-center rounded-xl border font-medium transition-colors ${
              spacious ? 'gap-2 px-3 py-4 text-sm' : 'gap-1 px-2 py-3 text-xs'
            } ${
              selected
                ? 'border-watsPrimary bg-watsPrimary/10 text-watsPrimary ring-2 ring-watsPrimary'
                : 'border-gray-200 bg-white text-gray-600 hover:bg-gray-50'
            }`}
          >
            <PaymentMethodGlyph method={method.id} className="h-6 w-6" />
            <span>{translate(method.labelKey, language)}</span>
          </button>
        );
      })}
    </div>
  );
}
